import { render, staticRenderFns } from "./VolunteerBackendProfileHeading.vue?vue&type=template&id=9761f24a&scoped=true&"
import script from "./VolunteerBackendProfileHeading.vue?vue&type=script&lang=js&"
export * from "./VolunteerBackendProfileHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9761f24a",
  null
  
)

export default component.exports